import Carousel from "react-slick";
import styled from "styled-components";
import { testimonialData } from "../../constant";
import TestimonialCard from "./TestimonialCard";
import withWindowDimensions from "../shared/withWindowDimensions";

const TestimonialSection = ({ isMobileSized }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          arrow: false,
          nextArrow: <></>,
          prevArrow: <></>,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrow: false,
          nextArrow: <></>,
          prevArrow: <></>,
          dots: true,
          autoplay: true,
        },
      },
    ],
  };
  return (
    <div
      style={
        !isMobileSized
          ? {
              display: "grid",
              gridTemplateColumns: "auto auto",
              gridGap: "40px",
            }
          : {}
      }
    >
      {isMobileSized ? (
        <StyledCarousel {...settings}>
          {testimonialData.map((testimonial) => (
            <div key={testimonial.id} className="pr-2 md:pr-12 pl-6">
              <TestimonialCard {...testimonial} />
            </div>
          ))}
        </StyledCarousel>
      ) : (
        testimonialData.map((testimonial) => (
          <div key={testimonial.id}>
            <TestimonialCard {...testimonial} />
          </div>
        ))
      )}
    </div>
  );
};

export default withWindowDimensions(TestimonialSection);

const StyledCarousel = styled(Carousel)`
  .slick-dots {
    bottom: -50px !important;
    > li {
      width: 15px;
      height: 15px;
      background-color: #3b3d7f;
      border-radius: 100%;
      & > button:before {
        font-size: 0 !important;
      }
      @media (max-width: 767px) {
        width: 10px;
        height: 10px;
      }
    }
    > .slick-active {
      background-color: #29bcb7;
    }
    @media (max-width: 767px) {
      bottom: -35px !important;
    }
  }
`;
